import * as _ from "lodash";
import React, { useState, useEffect } from "react";
import "./index.scss";
import Dropdown from "../../core/dropdown";
import {
  triggerConditions,
  triggerOperators,
} from "../../../constant/biz/trigger";
import { useTranslation } from "react-i18next";
import { CustomType } from "../../../constant/biz/enums";

const TriggerCondition = ({ config }) => {
  const { t } = useTranslation();
  const mapConfig = {
    id: "id",
    name: "text",
  };

  const [conditions, setConditions] = useState(_.get(config, "conditions", []));

  const onChange = _.get(config, "onChange", () => {});

  useEffect(() => {
    onChange(conditions);
  }, [conditions, onChange]);

  useEffect(() => {
    setConditions(_.get(config, "conditions", []));
  }, [config]);

  const removeCondition = (index) => {
    const updated = [...conditions];
    updated.splice(index, 1);
    setConditions(updated);
  };

  const handleFieldChange = (index, key, value) => {
    const updated = [...conditions];
    updated[index] = {
      ...updated[index],
      [key]: value,
    };
    setConditions(updated);
  };

  const handleSelectOperator = (index, operator) => {
    handleFieldChange(index, "operator", operator);
  };

  const handleValueChange = (index, value) => {
    handleFieldChange(index, "value", value);
  };

  const handleSelectCondition = (option) => {
    const fieldKey = _.get(option, "id");
    const conditionConfig = _.find(triggerConditions, { id: fieldKey });

    if (fieldKey) {
      const newCondition = {
        type: conditionConfig?.cond_type,
        fieldKey,
        operator: null,
        value: null,
      };
      setConditions([...conditions, newCondition]);
    }
  };

  return (
    <div>
      {conditions.map((condition, index) => {
        const fieldKey = _.get(condition, "fieldKey");
        const operator = _.get(condition, "operator");
        const value = _.get(condition, "value");
        const operators = triggerOperators[fieldKey] || [];
        const conditionConfig = _.find(triggerConditions, { id: fieldKey });
        const values = _.get(conditionConfig, "values");
        const typeValues = _.get(values, "type");
        const dataOptions = _.get(values, "data", []);

        return (
          <div
            key={condition._id || index}
            className="conditions-box d-flex flex-column gap-3 align-items-start mt-4"
          >
            <div className="d-flex gap-2 online-agents">
              <span className="btn btn-info-light text-nowrap">
                {t(conditionConfig.text)}
                <button
                  className="conditions-choosed fs-5 lh-1 ms-3"
                  data-name="online-agents"
                  onClick={() => removeCondition(index)}
                  style={{ border: "none", backgroundColor: "#E5E7F9" }}
                >
                  ×
                </button>
              </span>
              <Dropdown
                config={{
                  options: operators,
                  value: operator,
                  map: mapConfig,
                  onSelect: (option) =>
                    handleSelectOperator(index, _.get(option, "id")),
                  placeholder: "Trigger Operator",
                }}
              />
              {typeValues === CustomType.dropdown && (
                <Dropdown
                  config={{
                    options: dataOptions,
                    value: value,
                    map: mapConfig,
                    onSelect: (option) =>
                      handleValueChange(index, _.get(option, "id")),
                    placeholder: "Value",
                  }}
                />
              )}
              {typeValues === CustomType.numeric && (
                <input
                  className="form-control"
                  type="number"
                  value={value || 0}
                  onChange={(e) => handleValueChange(index, e.target.value)}
                />
              )}
              {typeValues === CustomType.text && (
                <input
                  className="form-control"
                  type="text"
                  value={value || ""}
                  onChange={(e) => handleValueChange(index, e.target.value)}
                />
              )}
            </div>
          </div>
        );
      })}

      <div className="dropdown mt-3">
        <Dropdown
          config={{
            options: triggerConditions,
            map: mapConfig,
            onSelect: handleSelectCondition,
            placeholder: t("settings.profile.profile_trigger.add_condition"),
          }}
        />
      </div>
    </div>
  );
};

export default TriggerCondition;
